/* ==========================================================================
   Trailing cursor ring
   Position is written once per animation frame with a transform, never with
   top/left, so the browser never has to lay the page out again while the mouse
   is moving.
   ========================================================================== */

(function () {
  'use strict';

  if (!window.matchMedia('(pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!document.documentElement.classList.contains('cursor-ring-enabled')) return;

  const ring = document.createElement('div');
  ring.className = 'cursor-ring';
  ring.setAttribute('aria-hidden', 'true');
  document.body.appendChild(ring);

  let targetX = window.innerWidth / 2;
  let targetY = window.innerHeight / 2;
  let x = targetX;
  let y = targetY;
  let running = false;

  const CLICKABLE = 'a, button, summary, [role="button"], label.quick__pill, label.facet__option';
  const DARK = '.masthead, .hero--ink, .hero--red, .footer--ink, .footer--red, .announcement--ink, .announcement--red, .divider--ink, .divider--red, .ink-bg';

  function frame() {
    // Ease toward the pointer. The gap is the whole effect; without it this is
    // just a second cursor drawn on top of the first.
    x += (targetX - x) * 0.18;
    y += (targetY - y) * 0.18;
    ring.style.transform = `translate3d(${x}px, ${y}px, 0)`;

    if (Math.abs(targetX - x) > 0.1 || Math.abs(targetY - y) > 0.1) {
      requestAnimationFrame(frame);
    } else {
      running = false;
    }
  }

  function start() {
    if (running) return;
    running = true;
    requestAnimationFrame(frame);
  }

  document.addEventListener(
    'pointermove',
    (event) => {
      if (event.pointerType !== 'mouse') return;
      targetX = event.clientX;
      targetY = event.clientY;
      ring.classList.add('is-active');
      start();
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerover',
    (event) => {
      const el = event.target;
      if (!(el instanceof Element)) return;
      ring.classList.toggle('is-over-link', !!el.closest(CLICKABLE));
      ring.classList.toggle('is-on-dark', !!el.closest(DARK));
    },
    { passive: true }
  );

  document.addEventListener('pointerdown', () => ring.classList.add('is-pressed'), { passive: true });
  document.addEventListener('pointerup', () => ring.classList.remove('is-pressed'), { passive: true });

  // Leaving the window or opening a tooltip should not leave a mark stranded.
  document.addEventListener('mouseleave', () => ring.classList.remove('is-active'));
  document.addEventListener('mouseenter', () => ring.classList.add('is-active'));
  window.addEventListener('blur', () => ring.classList.remove('is-active'));
})();
